import { createAsyncSliceWithDataAndQuery } from '../createAsyncSliceWithDataAndQuery';
import { getConversationsAsync } from '../../API/conversations/getConversationsAsync';
import { createDefaultPageData } from 'types/rest/IPageData';

export const { slice: lenderConversationsSlice, asyncAction: loadConversationsAction } =
  createAsyncSliceWithDataAndQuery('lenderConversationsSlice', getConversationsAsync, createDefaultPageData());
